import { createContext, useContext } from "react";

export type ParcelSectionGateState = {
  enabled: boolean;
  lockHint?: string;
};

const defaultState: ParcelSectionGateState = {
  enabled: true,
};

export const ParcelSectionGateContext =
  createContext<ParcelSectionGateState>(defaultState);

export function useParcelSectionGate(): ParcelSectionGateState {
  return useContext(ParcelSectionGateContext);
}
